import { render } from "./ChatBadge.vue?vue&type=template&id=63bcb3ce"
import script from "./ChatBadge.vue?vue&type=script&lang=js"
export * from "./ChatBadge.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__